import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import Form from '@afosto/app-components-react/Form';
import Checkbox from '@afosto/app-components-react/Checkbox';
import TextField from '@afosto/app-components-react/TextField';
import useForm from '@afosto/utils-react/validation/useForm';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage } from 'react-intl';
import translations from './translations';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Divider from '@material-ui/core/Divider';
import validationSchema from './validations';

const StepBackUpMethods = ({ onSubmit }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    defaultValues: {
      useEmail: false,
      useSms: false,
      email: '',
      sms: '',
    },
    onSubmit,
  });
  const { errors, watch } = form;
  const useEmail = watch('useEmail');
  const useSms = watch('useSms');

  return (
    <Form form={form} renderActions={false}>
      <Typography variant="body2">
        <FormattedMessage {...translations.formStep.backup.description} />
      </Typography>
      <Checkbox
        name="useEmail"
        label={intl.formatMessage({ ...translations.fields.emailCheckbox.label })}
      />
      <Collapse in={useEmail}>
        <TextField
          name="email"
          label={intl.formatMessage({ ...translations.fields.email.label })}
        />
      </Collapse>
      <Divider />
      <Checkbox
        name="useSms"
        label={intl.formatMessage({ ...translations.fields.smsCheckbox.label })}
      />
      <Collapse in={useSms}>
        <TextField
          name="sms"
          label={intl.formatMessage({ ...translations.fields.phoneNumber.label })}
        />
      </Collapse>
      {form.submitted && errors.atLeastOneMethod && (
        <Typography variant="caption" color="error">
          <FormattedMessage {...translations.errors.noChannelSelected} />
        </Typography>
      )}
      <Grid container justify="flex-end">
        <Button type="submit" variant="contained" color="primary">
          <FormattedMessage {...translations.formActions.next} />
        </Button>
      </Grid>
    </Form>
  );
};

StepBackUpMethods.propTypes = {
  onSubmit: PropTypes.func,
};

StepBackUpMethods.defaultProps = {
  onSubmit: undefined,
};

export default StepBackUpMethods;
